import React from 'react';
import EditDetails from '../components/EditDetails';

const AccountDetails: React.FC = () => {
  return (
    <>
      <h2>My Account</h2>
      <EditDetails />
    </>
  );
};

export default AccountDetails;
